module.exports = __webpack_public_path__ + "img/icon_map_2_off_110.4654d582.png";